import DriverPumpAdjustmentsDetail from 'pages/ComingMaterials/View/SalaryDrivers/Views/DriverPumpAdjustmentsDetail';

import {
  DriverMixerAdjustmentsDetail,
  DriverTonarAdjustmentsDetail,
  EmployeeAdjustmentsDetail,
  SalaryDriversInfo,
  SalaryDriversMain,
  SalaryEmployeeInfo,
  SalaryEmployeeMain,
  SalaryMixerDriversInfo,
  SalaryMixerDriversMain,
  SalaryPumpDriversInfo,
  SalaryPumpDriversMain,
} from '../../pages';

export const routingSalary = [
  {
    path: '/salary-tonar',
    exact: true,
    component: SalaryDriversMain,
    claims: ['CanLookSalaryTonarSection'],
  },
  {
    path: '/salary-tonar/:id',
    exact: true,
    component: SalaryDriversInfo,
    claims: ['CanLookSalaryTonarSection'],
  },
  {
    path: '/salary-tonar-adjustment/:id',
    exact: true,
    component: DriverTonarAdjustmentsDetail,
    claims: ['all'],
    //claims: ["CanLookPassCalculationSection"],
  },
  {
    path: '/salary-mixers',
    exact: true,
    component: SalaryMixerDriversMain,
    claims: ['CanLookSalaryMixerSection'],
  },
  {
    path: '/salary-mixers/:id',
    exact: true,
    component: SalaryMixerDriversInfo,
    claims: ['CanLookSalaryMixerSection'],
  },
  {
    path: '/salary-mixer-adjustment/:id',
    exact: true,
    component: DriverMixerAdjustmentsDetail,
    claims: ['all'],
  },
  {
    path: '/salary-employee-adjustment/:id',
    exact: true,
    component: EmployeeAdjustmentsDetail,
    claims: ['all'],
  },
  {
    path: '/salary-employee',
    exact: true,
    component: SalaryEmployeeMain,
    claims: ['CanLookSalaryFixedSection'],
  },
  {
    path: '/salary-employee/:id',
    exact: true,
    component: SalaryEmployeeInfo,
    claims: ['CanLookSalaryFixedSection'],
  },
  {
    path: '/salary-pump',
    exact: true,
    component: SalaryPumpDriversMain,
    claims: ['CanLookDriverPumpSalaryConfiguration'],
  },
  {
    path: '/salary-pump/:id',
    exact: true,
    component: SalaryPumpDriversInfo,
    claims: ['CanLookDriverPumpSalaryConfiguration'],
  },
  {
    path: '/salary-pump-adjustment/:id',
    exact: true,
    component: DriverPumpAdjustmentsDetail,
    claims: ['CanLookPumpAdjustments'],
  },
];
